import { useSnackbars } from '@customerio/pluma-components/react';
import { authStore } from '@/services/auth/store';
import { useStore } from '@nanostores/react';
import { hydraUiApi } from '@/services/api';
import { sentryCaptureException } from '@/utils/sentry';
import type { FeedbackFormValues } from '../types';

export function useSubmitFeedback() {
  const auth = useStore(authStore);
  const snackbars = useSnackbars();

  const submitFeedback = async (values: FeedbackFormValues): Promise<void> => {
    if (auth.account == null || auth.user == null) {
      throw new Error('Cannot submit feedback without auth data');
    }

    const { account } = auth;

    try {
      await hydraUiApi.support.feedback({
        params: { path: { account_id: String(account.id) } },
        body: {
          replyTo: values.replyTo,
          source: values.source ?? '',
          browser: navigator.userAgent,
          url: window.location.href,
          windowDimensions: `${window.innerWidth}x${window.innerHeight}`,
          criticism: values.criticism ?? '',
          praise: values.praise ?? '',
        },
      });

      snackbars.create({
        message: 'Thank you for your feedback!',
        variant: 'success',
      });
    } catch (error) {
      sentryCaptureException(error);
      snackbars.create({
        message: 'Unable to submit feedback. Please try again.',
        variant: 'error',
      });
      throw error;
    }
  };

  return submitFeedback;
}
